import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AceAuthOidcWrapperComponent } from '../IAM/aceAuthOidcWrapper.component';

@NgModule({
    declarations: [
        AceAuthOidcWrapperComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [
        AceAuthOidcWrapperComponent
    ]
})
export class WebComponentWrapperModule {
}